import { createContext } from 'react';
import { tIntercomContext } from 'src/hooks/Intercom/Intercom.types';

/**
 * @module providers/IntercomProvider
 * Context for sharing Intercom state and methods across the application.
 *
 * @description This context provides access to Intercom functionality throughout
 * the component tree, allowing any component to interact with the Intercom messenger.
 */
export const IntercomContext = createContext<tIntercomContext | null>(null);
